import { coursesApi } from './courses-base.api';
import type { GetDashboardOutput } from '../../types/dashboard.types';

const TAG = 'courses:dashboard' as const;

export const dashboardEndpoints = coursesApi.injectEndpoints({
	endpoints: (builder) => ({
		getDashboard: builder.query<GetDashboardOutput, void>({
			query: () => ({ url: 'courses/dashboard' }),
			providesTags: [TAG],
		}),
	}),
});

export const { useGetDashboardQuery, useLazyGetDashboardQuery } = dashboardEndpoints;
